module.exports = __webpack_public_path__ + "img/instagram.c3d69d7a.svg";